import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Separator,
  Container,
  Typography,
} from '@ublend-npm/aulaui-core';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';

import * as selectors from '@core/selectors/spaces';
import pushRoute from '@app/utils/routing';
import SpaceSelector from './SpaceSelector/SpaceSelector.container';
import SpacesSearch from './SpacesSearch.container';
import SpacesSearchInput from './SpacesSearchInput';
import SpacesShowArchivedSwitch from './SpacesShowArchivedSwitch';
import SpacesSortSelect from './SpacesSortSelect';
import RecentlyViewedSpaces from './RecentlyViewed/RecentlyViewed.conatiner';

const ACTION_HEIGHT = 48;

const MySpaces = () => {
  const [search, setSearch] = useState('');
  const [showArchived, setShowArchived] = useState(false);
  const [sort, setSort] = useState<'az' | 'za'>('az');

  // Get spaces from props, or from redux if not passed as prop
  // const { spaces } = props;
  // If not passed as prop, get from redux:
  const spaces = useSelector((state) =>
    selectors.alphabeticallySorted(selectors.spacesData(state))
  );

  const { webAppFtSpaceArea202504 } = useFlags();
  if (!webAppFtSpaceArea202504) pushRoute('/dashboard');

  // Changing document title
  useEffect(() => {
    document.title = `My spaces - Aula`;
  }, []);

  const hasArchivedSpaces =
    Array.isArray(spaces) && spaces.some((space) => space && space.archived);

  return (
    <Container>
      <Typography
        title="My spaces"
        aria-label="My Space"
        variant="h4"
        tabIndex={0}
        sx={{
          mb: {
            xs: '16px',
            md: '24px',
          },
        }}
      >
        My spaces
      </Typography>

      {/* Search and filter section */}
      <Box
        mb={{
          xs: '16px',
          md: '24px',
        }}
      >
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          gap={2}
          alignItems={{ xs: 'stretch', sm: 'center' }}
        >
          <Box flex={1} sx={{ height: `${ACTION_HEIGHT}px` }}>
            <SpacesSearchInput value={search} onChange={setSearch} />
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end"
            gap={{ xs: 1, sm: 3 }}
            sx={{ height: `${ACTION_HEIGHT}px` }}
          >
            {hasArchivedSpaces && (
              <Box sx={{ ml: { xs: '16px', sm: 0 } }}>
                <SpacesShowArchivedSwitch
                  checked={showArchived}
                  onChange={setShowArchived}
                />
              </Box>
            )}
            <SpacesSortSelect value={sort} onChange={setSort} />
          </Box>
        </Box>
      </Box>
      <Grid>
        <SpacesSearch search={search} showArchived={showArchived} sort={sort} />
      </Grid>

      {/* Recently viewed section */}
      <Box mt={{ xs: 2, md: 3 }}>
        <RecentlyViewedSpaces />
      </Box>
      <Separator sx={{ my: '0.5rem' }} />

      {/* Space Selector Section */}
      <Box pb="5rem">
        <SpaceSelector
          // search={search}  //if need searching feature on spaceselector component need to pass this prop
          showArchived={showArchived}
          sort={sort}
        />
      </Box>
    </Container>
  );
};

export default MySpaces;
